import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { commonPostPutFormData } from "../../../redux/reducers/commonApiSlice";
import { addFollowup, updateFollowup } from "../../../data/ApiEndpoints";
import SelectDropdown from "../../components-react/SelectDropdown";

const AddFollowupStatus = ({
  userInfoData,
  closeModal,
  callFunction,
  isEdit,
  rowData,
}) => {
  const dispatch = useDispatch();
  const { customerIntentCategory } = useSelector((state) => state.api);
  const { postPutLoadingFormData } = useSelector((state) => state.common);

  const [customerIntents, setCustomerIntents] = useState([]);
  const iniFormvalues = {
    selCustomerIntent: isEdit
      ? { label: rowData?.intent_name, value: rowData?.intent_id }
      : "",
    followupStatusLabel: isEdit ? rowData?.display_label : "",
    followupStatusValue: isEdit ? rowData?.value : "",
    isNextFollowupRequired:
      isEdit && rowData?.next_followup_required ? true : false,
    isPlanRequired: isEdit && rowData?.price_required ? true : false,
    isActive: isEdit && rowData?.status === "active" ? true : false,
    isWhatsappVerification: isEdit && rowData?.wap_verification ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormvalues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSubmit = () => {
    setFormErrors(validateFollowupForm(formValues));
    setIsSubmit(true);
  };

  function validateFollowupForm(formValues) {
    let errors = {};

    if (!formValues.selCustomerIntent) {
      errors.selCustomerIntent = "required!";
    }

    if (!formValues.followupStatusLabel) {
      errors.followupStatusLabel = "required!";
    }

    if (!formValues.followupStatusValue) {
      errors.followupStatusValue = "required!";
    }

    return errors;
  }

  const handleAdd = async (requestBody) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit ? updateFollowup : addFollowup;
    const token = userInfoData?.token;

    setIsSubmit(false);

    try {
      const result = await dispatch(
        commonPostPutFormData({ method, endpoint, requestBody, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        callFunction();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  useEffect(() => {
    if (
      customerIntentCategory?.status &&
      customerIntentCategory?.data?.length > 0
    ) {
      const allIntents = customerIntentCategory?.data?.map((item) => ({
        value: item?.uid || "",
        label: item?.name || "",
      }));

      setCustomerIntents(allIntents);
    } else {
      setCustomerIntents([]);
    }
  }, [customerIntentCategory]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        display_label: formValues.followupStatusLabel || "",
        value:
          formValues.followupStatusValue?.replace(/\s+/g, "_")?.toLowerCase() ||
          "",
        intent_id: formValues.selCustomerIntent?.value || "",
        next_followup_required: formValues.isNextFollowupRequired ? 1 : 0,
        price_required: formValues.isPlanRequired ? 1 : 0,
        wap_verification: formValues.isWhatsappVerification ? 1 : 0,
        status: formValues.isActive ? "active" : "inactive",
      };

      const formData = new FormData();

      for (const key in userData) {
        if (userData.hasOwnProperty(key)) {
          formData.append(key, userData[key]);
        }
      }

      if (isEdit) {
        formData.append("uid", rowData?.uid);
      }

      handleAdd(formData);
    }
  }, [isSubmit, formErrors]);

  console.log("formValues=> ", formValues);

  return (
    <div className="createNewCTOModalContainer mod-width-50p">
      <CommonHeadingNBtns
        title="add Follow up"
        btnTxt={isEdit ? "Update" : "Submit"}
        onClose={closeModal}
        onClick={onSubmit}
        isLoading={postPutLoadingFormData}
      />

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="selCustomerIntent" className="formInputLabel">
              Intent Category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selCustomerIntent ? "formError" : ""
              }`}>
              <SelectDropdown
                options={customerIntents}
                selectedOption={formValues.selCustomerIntent}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selCustomerIntent", selectedValue)
                }
                name="Customer Intent"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="followupStatusLabel" className={`formInputLabel `}>
              Display Name <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Display Name"
              className={`formInput ${
                formErrors?.followupStatusLabel ? "formError" : ""
              }`}
              name="followupStatusLabel"
              value={formValues.followupStatusLabel}
              onChange={onChangeInput}
            />
          </div>

          <div className="formInputBox">
            <label htmlFor="followupStatusValue" className={`formInputLabel `}>
              Follow Up Status Value <span className="required">*</span>
            </label>

            <input
              type="text"
              placeholder="Enter Value"
              className={`formInput ${
                formErrors?.followupStatusValue ? "formError" : ""
              }`}
              name="followupStatusValue"
              value={formValues.followupStatusValue}
              onChange={onChangeInput}
              disabled={isEdit}
            />
          </div>
        </div>

        <div className="formInputsGrid">
          <div className="formInputBox checkbox-wrapper span2">
            <div className={`flex-box`}>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                {formValues.isActive ? "Active" : "Not Active"}
              </label>
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isNextFollowupRequired"
                  checked={formValues.isNextFollowupRequired}
                  onChange={onChangeInput}
                />
                {formValues.isNextFollowupRequired
                  ? "Next Follow-up Status Required"
                  : "Next Follow-up Status Not Required"}
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isPlanRequired"
                  checked={formValues.isPlanRequired}
                  onChange={onChangeInput}
                />
                {formValues.isPlanRequired
                  ? "Plan Info Required"
                  : "Plan Info Not Required"}
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isWhatsappVerification"
                  checked={formValues.isWhatsappVerification}
                  onChange={onChangeInput}
                />
                {formValues.isWhatsappVerification
                  ? "WhatsApp Verification Required"
                  : "WhatsApp Verification Not Required"}
              </label>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddFollowupStatus;
